import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { NeutralColors } from '@fluentui/theme';
import classNames from 'classnames';
import { sortTermPrices } from '@shared/utils/pricing';
import { subtotalColumnKey } from '../saasPricingTableColumns';
import { mergeStyleSets, Stack } from '@fluentui/react';
const classes = mergeStyleSets({
    cell: {
        borderBottom: `1px solid ${NeutralColors.gray30}`
    },
    rightBorder: {
        borderRight: `1px solid ${NeutralColors.gray20}`
    },
    topBorder: {
        borderTop: `1px solid ${NeutralColors.gray20}`
    },
    padding: {
        padding: '16px'
    },
    subtotalCell: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});
export const SaasPricingRow = ({ item, columns, rowWidth })=>{
    const { sku, futurePriceSku } = item;
    const sortedPrices = useMemo(()=>sortTermPrices(sku.termPrices), [
        sku.termPrices
    ]);
    const multilineColumns = useMemo(()=>columns.filter((column)=>column.isMultiline), [
        columns
    ]);
    const numberOfPrices = sortedPrices.length;
    const cellHeightPercentage = `${100 / numberOfPrices}%`;
    const getRowsForColumn = (column)=>multilineColumns.includes(column) ? sortedPrices : [
            sortedPrices[0]
        ];
    const getCellStyle = (column)=>({
            width: column.calculatedWidth,
            maxWidth: column.calculatedWidth
        });
    return /*#__PURE__*/ _jsx(Stack, {
        role: "row",
        horizontal: true,
        horizontalAlign: "start",
        style: {
            width: rowWidth
        },
        children: columns.map((column, columnIndex)=>{
            const rowsForColumn = getRowsForColumn(column);
            return /*#__PURE__*/ _jsx(Stack, {
                role: "cell",
                style: getCellStyle(column),
                className: classNames(classes.cell, {
                    [classes.rightBorder]: columnIndex !== columns.length - 1,
                    [classes.subtotalCell]: column.key === subtotalColumnKey
                }),
                children: rowsForColumn.map((price, index)=>{
                    const isTopBorder = index !== 0;
                    const stackHeight = rowsForColumn.length > 1 ? cellHeightPercentage : 'auto';
                    const className = classNames(classes.padding, {
                        [classes.topBorder]: isTopBorder
                    });
                    return /*#__PURE__*/ _jsx(Stack, {
                        className: className,
                        style: {
                            height: stackHeight
                        },
                        children: column.onRender({
                            sku,
                            futurePriceSku,
                            price
                        })
                    }, index);
                })
            }, column.key);
        })
    });
};
